import React from "react";

import {
  AddBusinessRounded,
  DashboardRounded,
  MenuBookRounded,
  ShoppingBasketRounded,
} from "@mui/icons-material";
import { BottomNavigation, BottomNavigationAction, Box, Paper } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import storageKey from "../../config/storageKey";
import { GreyPallet } from "../../config/styles";
import useCafeteria from "./context";

import MainSolidButton from "../../components/MainSolidButton";
import LoadingPage from "../LoadingPage";
import ModalWriteCafeteria from "./components/ModalWriteCafeteria";

export default function CafeteriaPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const [showModalCreate, setShowModalCreate] = React.useState(false);

  const { handleGetCafeterias, isLoadingCafeterias, currentCafeteria } = useCafeteria();

  const DISABLE_BOTTOM_PAD = window.localStorage.getItem(storageKey.DISABLE_BOTTOM_PAD);

  const [activeTab, setActiveTab] = React.useState<number | false>(false);

  const handleSetBottomActive = () => {
    if (location.pathname.startsWith("/cafeteria/dashboard")) setActiveTab(1);
    else if (location.pathname.startsWith("/cafeteria/menu")) setActiveTab(2);
    else if (location.pathname.startsWith("/cafeteria/orders")) setActiveTab(3);
    else if (location.pathname.startsWith("/cafeteria/settings")) setActiveTab(4);
    else navigate("/cafeteria/dashboard");
  };

  const onCloseHandler = (reload?: boolean) => {
    setShowModalCreate(false);
    if (reload) handleGetCafeterias();
  };

  React.useEffect(() => {
    handleSetBottomActive();
    if (!currentCafeteria) handleGetCafeterias();
  }, []);

  React.useEffect(() => {
    handleSetBottomActive();
  }, [location]);

  return isLoadingCafeterias ? (
    <LoadingPage />
  ) : currentCafeteria ? (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
      pt={"30px"}
      pb={"110px"}
    >
      {/* <MainBar /> */}

      <Box width={"90%"}>
        <Outlet />
      </Box>

      {activeTab !== 4 && (
        <Paper
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            borderTop: `3px solid ${GreyPallet.LightGhost}`,
            borderRadius: 0,
            zIndex: 100,
            "& .MuiSvgIcon-root": {
              fontSize: 30,
            },
          }}
        >
          <BottomNavigation
            showLabels
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            style={{
              padding: `5px 0px ${DISABLE_BOTTOM_PAD ? "5" : "20"}px 0px`,
              backgroundColor: "#fff",
            }}
          >
            <BottomNavigationAction
              value={1}
              onClick={() => navigate("/cafeteria/dashboard")}
              icon={<DashboardRounded />}
              label="Resumo"
            />

            <BottomNavigationAction
              value={2}
              onClick={() => navigate("/cafeteria/menu")}
              icon={<MenuBookRounded />}
              label="Cardápio"
            />

            <BottomNavigationAction
              value={3}
              onClick={() => navigate("/cafeteria/orders")}
              icon={<ShoppingBasketRounded />}
              label="Pedidos"
            />
          </BottomNavigation>
        </Paper>
      )}
    </Box>
  ) : (
    <>
      {showModalCreate && <ModalWriteCafeteria onClose={onCloseHandler} />}

      <MainSolidButton
        icon={<AddBusinessRounded />}
        text="Criar uma Lanchonete"
        onClick={() => setShowModalCreate(true)}
      />
    </>
  );
}
